module.exports = __webpack_public_path__ + "files/15572277244b392129048f7b1150f7a7.png";